import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_SUBSCRIPTION_LINK } from './url-constants';

type GetSubscriptionLinkEndpointSpecification = ApiEndpointSpecification;
export const GetSubscriptionLinkEndpointSpecification: GetSubscriptionLinkEndpointSpecification = {
    url: GET_SUBSCRIPTION_LINK,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetSubscriptionLinkRequestParams',
    requestBodySchemaName: 'GetSubscriptionLinkRequestBody',
    okResponseSchemaName: 'GetSubscriptionLinkOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeGetSubscriptionLink = Helpers.makeApiRequestFn<
    Types.GetSubscriptionLinkRequestParams,
    Types.GetSubscriptionLinkRequestBody,
    Types.GetSubscriptionLinkOkResponse
>(GetSubscriptionLinkEndpointSpecification);
